module.exports = __webpack_public_path__ + "img/eamaster_logo.28439d0a.png";